import { useEffect } from 'react';
import { useReactOidc } from '@axa-fr/react-oidc-context';
import { BaseAuthenticationResource } from '../resources/BaseAuthenticationResource';

export const AuthenticateResources = () => {
  const oidc = useReactOidc();

  useEffect(() => {
    if (oidc.oidcUser) {
      BaseAuthenticationResource.bearerToken = oidc.oidcUser.id_token;
    }
  }, [oidc]);

  return <></>;
};
